import anime from 'animejs'

const initAnims = () => {

    // const h1s = document.querySelectorAll(".entry-header h1, .entry-header .page-title");
    // h1s.length > 0 && window.fitText(h1s  , 0.75);

 

}


export default initAnims;